import React from 'react';
import Button from '../../atoms/button/Button';
import { CogIcon } from '../../pages/paths/assets/icons';
import { useDrag, useDrop } from 'react-dnd';

const ItemTypes = {
  STEP: 'step'
};

const EditStepItem = ({
  index,
  className,
  material_type,
  step,
  stepNumber,
  statusLabel,
  edit,
  handleEditChange,
  handleCancelEdit,
  handleRemoveStep,
  moveStep
}) => {
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.STEP,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });

  const [, drop] = useDrop({
    accept: ItemTypes.STEP,
    drop: (item) => {
      if (item.index === index) return;
      moveStep(item.index, index);
      item.index = index;
    }
  });

  const setStepRef = (node) => {
    if (!node) return;
    drag(drop(node));
  };

  return (
    <div className={`${className} ${isDragging ? 'dragging' : ''}`} ref={setStepRef}>
      {edit ? (
        <>
          <button type="button" className="move-icon" ref={drag}>
            <CogIcon />
          </button>
          <div className="step-block__edit-badge">Step {stepNumber}</div>
          <input type="text" name="name" value={step.name} onChange={handleEditChange} className="step-name" />
          <input type="text" name="title" value={step.title} onChange={handleEditChange} className="step-title" />
          {material_type !== 'paths' && (
            <textarea type="text" name="description" value={step.description} onChange={handleEditChange} className="step-description" />
          )}
          <div className="un-btn-group left">
            <Button className={'ghost'} onClick={handleCancelEdit}>
              Save
            </Button>
            <Button className={'ghost red'} onClick={() => handleRemoveStep(step.id)}>
              Delete
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="step-block__summary">
            <span className="step-block__number">{stepNumber}</span>
            <div className="step-block__copy">
              <p className="step-title">{step.title || step.name}</p>
              <p className="step-status">{statusLabel}</p>
            </div>
            <button
              type="button"
              className="step-block__drag-handle"
              aria-label={`Reorder ${step.title || step.name}`}
              title={`Reorder ${step.title || step.name}`}
            >
              <CogIcon />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EditStepItem;
